import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../contexts/UserContext";
import api from "../../../services/api";
import { IconClose, IconDownload, IconFilter, IconSearch } from "../../icons";
import { Container, DownloadFile, ModalContent, ModalTitle } from "./styles";
import {clarity} from "react-microsoft-clarity";
import ModalDefault from "../../ModalDefault";
import ButtonDefault from "../../form/ButtonDefault";
import Checkbox from "../../form/InputCheckbox";
import { toast } from "react-hot-toast";
import { toastDefs, toastDefsError } from '../../../config/toastConfig';
import { comum } from "../../../styles/Themes/light";

interface FilterProps {
    filters?: any,
    countieSelected?: any,
    planSelected?: any,
    initialDate?: any,
    finalDate?: any,
    island?: any,
    sector?: any,
    setFilters?: any,
    setSearchProfiles?: any,
    setClean?: any,
}

export default function ProfessionalsFilter(
    {
        filters,
        countieSelected,
        planSelected,
        initialDate,
        finalDate,
        island,
        sector,
        setFilters,
        setSearchProfiles,
        setClean,

    }: FilterProps) {

    const { pageName } = useAuth();
    const filterRef = useRef<any>();
    const [ DTOSearch, setDTOSearch ] = useState<any>();
    const [ openFiltersMenu, setOpenFiltersMenu ] = useState<boolean>(false);
    const [ openModal, setOpenModal ] = useState<boolean>(false);
    const [ checkedBox, setCheckedBox ] = useState<string[]>([]);

    function handleOnChanges(value: any) {
        setDTOSearch(value)
    }

    function clearSearch() {
        setDTOSearch('')
        setSearchProfiles('')
    }

    function searchKeyPressed(event: any) {

        if (event.key === 'Enter') {
            setSearchProfiles(DTOSearch)
        }

    }

    const handleToggleAll = (type: string) => {
        const fields = type === 'Profissionais' 
            ? dataCheckbox.profissionais.map(item => item.value)
            : dataCheckbox.operadores.map(item => item.value);
        
        if (checkedBox.length === fields.length) {
            setCheckedBox([]);
        } else {
            setCheckedBox(fields);
        }
    };

    const isAllSelected = (type: string) => {
        const fields = type === 'Profissionais'
            ? dataCheckbox.profissionais.map(item => item.value)
            : dataCheckbox.operadores.map(item => item.value);
        return checkedBox.length === fields.length;
    };

    async function downloadProfessionals() {
        try {
            clarity.setEvent('relatorio-profissionais');
            setOpenModal(false);

            const fields = checkedBox.reduce((acc: any, field: string) => {
                acc[field] = true;
                return acc;
            }, {});

            if (Object.keys(fields).length === 0) {
                toast.error('É necessário selecionar ao menos um campo para exportar o relatório', toastDefsError);
                return;
            }

            const params: any = {};
            if (filters && filters.length > 0) {
                if (filters.includes('comarca') && countieSelected) {
                    const cidadeMatch = countieSelected.match(/\s*-\s*(.+)/);
                    params.comarca = cidadeMatch ? cidadeMatch[1].trim() : countieSelected;
                }
                if (filters.includes('plano') && planSelected) {
                    params.plano = planSelected.value;
                }
                if (filters.includes('periodo') && initialDate && finalDate) {
                    params.dataInicio = new Date(initialDate).toISOString().slice(0, 19).replace('T', ' ');
                    params.dataFim = new Date(finalDate).toISOString().slice(0, 19).replace('T', ' ');
                }
            }

            const response = await toast.promise(
                api.post('usuario-csv', { filter: params, fields }),
                {
                    loading: 'Gerando relatório...',
                    success: 'Relatório de Profissionais gerado com sucesso!',
                    error: 'Erro ao gerar relatório de profissionais. Tente novamente.'
                },
                {
                    loading : {
                        style: {
                            padding: '16px',
                            background: 'var(--cffffff)',
                            color: 'var(--toast-ink)',
                        },
                        iconTheme: {
                            primary: comum.colors.primaryBlue400,
                            secondary: comum.colors.secondaryPool100,
                        },
                    },
                    success: {
                        style : {
                            padding: '16px',
                            color: 'var(--toast-ink)',
                            background: 'var(--ce7f8eb)',
                            border: '2px solid #9EE4AF',
                        },
                        iconTheme: {
                            primary: comum.colors.interfaceSuccess,
                            secondary: comum.colors.interfaceSuccess200,
                        },
                    },
                    error : {
                        style: {
                            padding: '16px',
                            background: 'var(--cffffff)',
                            color: 'var(--toast-ink)',
                        },
                        iconTheme: {
                            primary: 'var(--cf24343)',
                            secondary: 'var(--cfffaee)',
                        },
                    }
                }

            );

            const url = window.URL.createObjectURL(new Blob([s2ab(response.data)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Relatório Profissionais.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error: any) {
            console.log('log error download csv', error);
            toast.error('Ocorreu um erro durante a geração do relatório. Tente novamente em alguns instantes.', toastDefsError);
        }
    }

    async function downloadOperators() {
        try {
            clarity.setEvent('relatorio-operador');
            setOpenModal(false);

            const fields = checkedBox.reduce((acc: any, field: string) => {
                acc[field] = true;
                return acc;
            }, {});

            if (Object.keys(fields).length === 0) {
                toast.error('É necessário selecionar ao menos um campo para exportar o relatório', toastDefsError);
                return;
            }

            const params: any = {};
            if (filters.includes('ilhas') && island) {
                params.id_ilha = island;
            }
            if (filters.includes('setor') && sector) {
                params.setor = sector;
            }

            const response = await toast.promise(
                api.post('operador-csv', { filter: params, fields }),
                {
                    loading: 'Gerando relatório...',
                    success: 'Relatório de Operadores gerado com sucesso!',
                    error: 'Erro ao gerar relatório de operadores. Tente novamente.'
                },
                {
                    loading : {
                        style: {
                            padding: '16px',
                            background: 'var(--cffffff)',
                            color: 'var(--toast-ink)',
                        },
                        iconTheme: {
                            primary: comum.colors.primaryBlue400,
                            secondary: comum.colors.secondaryPool100,
                        },
                    },
                    success: {
                        style : {
                            padding: '16px',
                            color: 'var(--toast-ink)',
                            background: 'var(--ce7f8eb)',
                            border: '2px solid #9EE4AF',
                        },
                        iconTheme: {
                            primary: comum.colors.interfaceSuccess,
                            secondary: comum.colors.interfaceSuccess200,
                        },
                    },
                    error : {
                        style: {
                            padding: '16px',
                            background: 'var(--cffffff)',
                            color: 'var(--toast-ink)',
                        },
                        iconTheme: {
                            primary: 'var(--cf24343)',
                            secondary: 'var(--cfffaee)',
                        },
                    }
                }

            );

            const url = window.URL.createObjectURL(new Blob([s2ab(response.data)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Relatório Operadores.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error: any) {
            console.log('log error download csv', error);
            toast.error('Ocorreu um erro durante a geração do relatório. Tente novamente em alguns instantes.', toastDefsError);
        }
    }

    function s2ab(s:any) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    function handleCheckbox(name: string, value: boolean) {
        if (value) {
            setCheckedBox([...checkedBox, name]);
        } else {
            setCheckedBox(checkedBox.filter(item => item !== name));
        }
    };

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {

            if (openFiltersMenu && filterRef.current && !filterRef.current.contains(e.target)) {
                setOpenFiltersMenu(false);
            }

        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [openFiltersMenu]);

    const dataCheckbox = {
        profissionais: [
            { value: 'id'           , placeholder: "ID"            },
            { value: 'nome'         , placeholder: "Nome"          },
            { value: 'razao'        , placeholder: "Razão Social"  },
            { value: 'tipo'         , placeholder: "Tipo"          },
            { value: 'inscricaoOab' , placeholder: "Inscrição OAB" },
            { value: 'tipoOab'      , placeholder: "Tipo OAB"      },
            { value: 'estadoOab'    , placeholder: "Estado OAB"    },
            { value: 'whatsapp'     , placeholder: "WhatsApp"      },
            { value: 'cnpj'         , placeholder: "CNPJ"          },
            { value: 'cpf'          , placeholder: "CPF"           },
            { value: 'email'        , placeholder: "Email"         },
            { value: 'dataCadastro' , placeholder: "Data Cadastro" },
        ],
        operadores : [
            { value: 'id'           , placeholder: "ID"                 },
            { value: 'nome'         , placeholder: "Nome"               },
            { value: 'emailProf'    , placeholder: "Email Profissional" },
            { value: 'emailPess'    , placeholder: "Email Pessoal"      },
            { value: 'telefone'     , placeholder: "Telefone"           },
            { value: 'cidade'       , placeholder: "Cidade"             },
            { value: 'uf'           , placeholder: "UF"                 },
            { value: 'audiencia'    , placeholder: "Audiências"         },
            { value: 'protocolo'    , placeholder: "Protocolos"         },
            { value: 'diligencia'   , placeholder: "Diligências"        },
            { value: 'peticao'      , placeholder: "Petições"           },
            { value: 'acautelamento', placeholder: "Acautelamentos"     },
            { value: 'status'       , placeholder: "Status"             },
            { value: 'dataCadastro' , placeholder: "Data Cadastro"      },
        ],
    }

    return (
        <Container filter={filters}>
            <div className="search">
                <div
                    className="buscar"
                    onClick={() => setSearchProfiles(DTOSearch)}
                >
                    <IconSearch/>
                </div>
                <input
                    placeholder="Pesquisar"
                    onChange={(e) => handleOnChanges(e.target.value)}
                    onKeyDown={(e) => searchKeyPressed(e)}
                    value={DTOSearch}
                />
                {
                    DTOSearch &&
                    <div
                        className="clean-search"
                        onClick={() => clearSearch()}
                    >
                        <IconClose />
                    </div>
                }
            </div>

            <div
                className="button"
                ref={filterRef}
                onClick={() => setOpenFiltersMenu(!openFiltersMenu)}
            >
                {
                    filters?.length < 1
                    ?   <div className="button-filter">
                            <IconFilter />
                            Filtrar
                        </div>
                    :   <div className="button-filter">
                            <div className="icon-filter">
                                <IconFilter />
                            </div>
                            <div>
                                {filters?.length}
                            </div>
                            <div
                                className="clear-icon"
                                onClick={() => { setFilters([]); setClean(); }}
                            >
                                <IconClose />
                            </div>
                        </div>
                }

                {
                    pageName === 'Profissionais' &&
                    <div className={openFiltersMenu ? 'hidden-menu' : 'hidden-menu no-show'}>
                        <div
                            className="filters"
                            onClick={() => setFilters((filters: any) => [...filters, 'plano'])}
                        >
                            Plano
                        </div>
                        <div
                            className="filters"
                            onClick={() => setFilters((filters: any) => [...filters, 'comarca'])}
                        >
                            Comarca
                        </div>
                        <div
                            className="filters"
                            onClick={() => setFilters((filters: any) => [...filters, 'periodo'])}
                        >
                            Período de cadastro
                        </div>
                    </div>
                }

                {
                    pageName === 'Operadores' &&
                    <div className={openFiltersMenu ? 'hidden-menu' : 'hidden-menu no-show'}>
                        <div
                            className="filters"
                            onClick={() => setFilters((filters: any) => [...filters, 'ilhas'])}
                        >
                            Ilha
                        </div>
                        <div
                            className="filters"
                            onClick={() => setFilters((filters: any) => [...filters, 'setor'])}
                        >
                            Setor
                        </div>
                    </div>
                }

            </div>
            {
                <DownloadFile onClick={() => setOpenModal(true)}>
                    <IconDownload />
                </DownloadFile>
            }

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setOpenModal(false)}
                openModal={openModal}
                width="auto"
                maxWidth="1200px"
                maxHeight="auto"
            >
                <ModalTitle>
                    <div>Exportar Relatório de {pageName}</div>
                    <div className="close" onClick={() => setOpenModal(false)}>
                        <IconClose />
                    </div>
                </ModalTitle>
                <ModalContent className="w-full max-w-6xl flex flex-col">
                    <div className="p-5 flex flex-col gap-2 overflow-y-auto max-h-[calc(100vh-300px)]">
                        <span className="title">Selecione os campos para emissão do relatório</span>
                        <div className="grid grid-cols-3 gap-5 mb-16">
                            {
                                pageName === 'Profissionais' &&
                                dataCheckbox.profissionais.map((item: any) => (
                                    <div key={item.value} className="col-span-1 flex flex-row">
                                        <Checkbox
                                            name={item.value}
                                            value={checkedBox.includes(item.value)}
                                            onClick={handleCheckbox}
                                            placeholder={item.placeholder}
                                        />
                                    </div>
                                ))
                            }
                            {
                                pageName === 'Operadores' &&
                                dataCheckbox.operadores.map((item: any) => (
                                    <div key={item.value} className="col-span-1 flex flex-row">
                                        <Checkbox
                                            name={item.value}
                                            value={checkedBox.includes(item.value)}
                                            onClick={handleCheckbox}
                                            placeholder={item.placeholder}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        {
                            pageName === 'Profissionais' &&
                            <div className="flex flex-row gap-3 justify-end">
                                <ButtonDefault className="cancel" onClick={() => handleToggleAll('Profissionais')}>
                                    {isAllSelected('Profissionais') ? 'Desmarcar Todos' : 'Selecionar Todos'}
                                </ButtonDefault>
                                <ButtonDefault className="continue" onClick={() => downloadProfessionals()}>
                                    Exportar
                                </ButtonDefault>
                            </div>
                        }
                        {
                            pageName === 'Operadores' &&
                            <div className="flex flex-row gap-3 justify-end">
                                <ButtonDefault className="cancel" onClick={() => handleToggleAll('Operadores')}>
                                    {isAllSelected('Operadores') ? 'Desmarcar Todos' : 'Selecionar Todos'}
                                </ButtonDefault>
                                <ButtonDefault className="continue" onClick={() => downloadOperators()}>
                                    Exportar
                                </ButtonDefault>
                            </div>
                        }
                    </div>
                </ModalContent>
            </ModalDefault>

        </Container>
    )
}
